import axios from 'axios';

export default function useErrorLogging() {
    const logError = async (error, page) => {
        try {
            await axios.get('/api/log-error', { 
                error: error.message || error,
                page: page,
                url: window.location.href,
                timestamp: new Date().toISOString()
            });
        } catch (err) {
            console.error('Failed to log error:', err);
        }
    };

    return {
        logError
    };
} 